import script from "./Settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./Settings.vue?vue&type=script&setup=true&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=59c888f2&lang=scss"

const __exports__ = script;

export default __exports__